import styled from '@emotion/styled'

import { spacing } from 'main/ui'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`

export const ContentContainer = styled.div`
  flex-grow: 1;
  margin-left: ${spacing.majorScale(3)}px;
  margin-right: ${spacing.majorScale(3)}px;
  margin-top: ${spacing.majorScale(3)}px;
`

export const FooterContainer = styled.div`
  margin-top: ${spacing.majorScale(8)}px;
  width: 100%;
`
